import componentHelper from '../../modules/component_helper.js';

angular.module('vastdesk').
  component('postalCodeTargeting',  {
    bindings: {
      formName: '@',
      formId: '@',
      allowList: '@',
      geoSource: '@',
      selectedLists: '<',
      selectedOptions: '<',
      dspSub: '<',
      demandPartnerPermissionIds: "<",
      demandPartnerPermissionsInputId: "<"
    },
    template: require("../templates/postalCodeTargeting.html"),
    controllerAs: '$postalCodeTargetingCtrl',
    controller: function() {
      this.allowlistButtonOptions = componentHelper.targetingOptions();
      this.targetingSourceOptions = componentHelper.targetingSourceOptions();
      this.$onInit = function() {
        this.placeholder = this.dspSub ? "10001, SW1A, 75001, B1228" : "10001, GB:SW1A, FR:75001, AR:B1228";
      };
    }
});
